export const NAVIGATION_LOGO_SIZES = {
    sm: 30,
    lg: 43,
};
